module.exports = __webpack_public_path__ + "static/media/kw.6d73a9fa.svg";